/*
 * @Autor: chentianyang
 * @Date: 2021-08-03 19:20:08
 * @LastEditors: chentianyang
 * @LastEditTime: 2021-08-03 19:33:17
 * @FilePath: \st-teacher-2020\src\store\modules\customLecturesDialog.ts
 */
interface CustomLecturesDialog {
  visible: boolean;
  currentClass: any;
}
const customLecturesDialog = {
  namespaced: true,
  state: {
    visible: false, // 弹窗是否可见
    currentClass: {}, // 选中的班级
  },
  getters: {
    getVisible(state: CustomLecturesDialog) {
      return state.visible;
    },
    getCurrentClass(state: CustomLecturesDialog) {
      return state.currentClass;
    },
  },
  mutations: {
    updateVisible(state: CustomLecturesDialog, data: boolean) {
      state.visible = data;
    },
    updateCurrentClass(state: CustomLecturesDialog, data: any) {
      state.currentClass = data;
    },
  },
  actions: {
  },
};

export default customLecturesDialog;
